import React from 'react';

import './page.scss';

export function PageMainTitle(props: { title: string }) {
  return <h1 className='page-main__title'>{props.title}</h1>;
}
